const FILE_ITEM_ENUMS = {
    FILESYSTEM_SUBTYPE_FILE: 1,
    FILESYSTEM_SUBTYPE_DIRECTORY: 2,
    FILESYSTEM_SUBTYPE_SYMLINK: 8,
    FILESYSTEM_SUBTYPE_MOUNTPOINT: 16,
    FILESYSTEM_SUBTYPE_DISK: 32
};

class FileItem {
    constructor() {
        this.displayName = '';
        this.uuid = '';
        this.size = 0;
        this.fullItemName = '';
        this.modificationTime = 0;
        this.type = '';
        this._selected = false;
    }

    static fromRaw(raw, folder) {
        let file = new FileItem();

        file.displayName = raw.displayName;
        file.uuid = raw.fullItemName;
        file.size = raw.fileSize;
        file.fullItemName = raw.fullItemName;
        file.modificationTime = raw.modificationTime;
        file._selected = folder._selected;
        file.type = raw.type;
        file.parent = folder;
        file.iconType = FileItem.changeIconType(raw.subType);
        file.mounted = raw.mounted;

        return file;
    }

    static changeIconType(subType) {
        if (!subType) return;
        let type = '';
        if (FileItem.isFile(subType)) {
            if (FileItem.isSymlink(subType)) {
                type = 'icon-symfile';
            } else {
                type = 'icon-file';
            }
        } else if (FileItem.isDirectory(subType)) {
            if (FileItem.isMountPoint(subType)) {
                if (FileItem.isSymlink(subType)) {
                    type = 'icon-symmountpoint';
                } else {
                    type = 'icon-mountpoint';
                }
            } else if (FileItem.isSymlink(subType)) {
                type = 'icon-symfolder';
            } else {
                type = 'icon-folder-1';
            }
        } else if (FileItem.isMountPoint(subType)) {
            if (FileItem.isSymlink(subType)) {
                type = 'icon-symmountpoint';
            } else {
                type = 'icon-mountpoint';
            }
        } else if (FileItem.isSymlink(subType) && FileItem.isError(subType)) {
            type = 'icon-symfile';
        }
        return type;
    }

    static isDisk(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_DISK) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_DISK;
    }

    static isFile(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_FILE) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_FILE;
    }
    static isDirectory(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_DIRECTORY) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_DIRECTORY;
    }
    static isMountPoint(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_MOUNTPOINT) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_MOUNTPOINT;
    }
    static isSymlink(subType) {
        return (subType & FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_SYMLINK) == FILE_ITEM_ENUMS.FILESYSTEM_SUBTYPE_SYMLINK;
    }
    static isError(subType) {
        return !(FileItem.isFile(subType) || FileItem.isDirectory(subType) || FileItem.isSymlink(subType));
    }
}

module.exports = FileItem;


// WEBPACK FOOTER //
// ./src/azurebackup/model/FileItem.js